import { Helmet } from "react-helmet-async";
import StaticMetas from "./staticMeta.json";
import { useInfo } from "../../context/InfoContext";

const MetaTag = ({
  title = "JainGlory Foundation: Granth, Blogs, Tirth and Resources",
  description = "",
  img = "https://jainglory.in/logo512.png",
  url = "",
  isPathStatic = "/",
}) => {
  const { data: userInfo } = useInfo();
  const orgName = userInfo?.title || "JainGlory Foundation";
  const orgDescription = userInfo?.description || "";

  if (!url) {
    isPathStatic = isPathStatic?.split("/")[1] || isPathStatic;
    isPathStatic = isPathStatic !== "/" ? "/" + isPathStatic : "/";
    const findStaticMeta = StaticMetas.find(
      (meta) => meta.path === isPathStatic
    );
    if (findStaticMeta) {
      url = window.location.href;
      title = findStaticMeta.title;
      description = findStaticMeta.description;
    } else {
      url = window.location.href;
    }
  }
  title = title
    ? `${orgName} | ` + title
    : `${orgName}: Granth, Blogs, Tirth and Resources`;
  description =
    description ||
    orgDescription ||
    "Reviving the lost Jain Heritage, History & Ancient Glory of Jainism Temples • Sculptures • Culture • Research. Since 2012";
  img = img || "https://jainglory.in/logo512.png";
  return (
    <Helmet>
      <title>{title}</title>
      <link rel="canonical" href={url} />
      <meta name="description" content={description} />
      {/* Open Graph tags (OG) */}
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {/* OG image tags */}
      <meta property="og:image" content={img} />
      <meta property="og:image:secure_url" content={img} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="200" />
      <meta property="og:image:alt" content={`Image of ${title} site`} />
      {/* Twitter tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": title,
          "url": url,
          "description": description,
          "image": img
        })}
      </script>
    </Helmet>
  );
};
export default MetaTag;
